import useUserPreferences from "hooks/useUserPreferences";

export default function useMarketMapPreferences(userId) {
  return useUserPreferences(userId);
}
